
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'GSRVerificationStep',

  props: {
    title: {
      type: String,
      required: true
    },
    sequence: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    isComplete: {
      type: Boolean,
      default: false
    }
  },

  meta: {
    auth: {
      strict: true,
      redirectToLogin: true
    }
  }
})
